// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xoon","newExpiryDate":"styles_newExpiryDate__l7twa","footer":"styles_footer__j_N7g"};